// src/services/apiClient.js
//const API_BASE = "http://localhost:3002";
const isLocal = window.location.origin.includes("localhost");
const API_BASE = isLocal ? "http://localhost:3002/api/v1" : "https://www.weekerai.de/api/v1";

// Helper to read cookies
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return decodeURIComponent(match[2]);
  return null;
}

export async function apiClient(route, { token, method = "GET", body, headers = {}, returnBlob = false, ...restOptions } = {}) {
  const url = `${API_BASE}${route}`
  const defaultHeaders = {};

  if (token) {
    defaultHeaders["Authorization"] = `Bearer ${token}`;
  }

  const isFormData = body instanceof FormData;

  // Only add JSON header if body is present and content-type not overridden, and NOT FormData
  if (body && !headers["Content-Type"] && !isFormData) {
    defaultHeaders["Content-Type"] = "application/json";
  }

  // CSRF Protection: Add X-XSRF-TOKEN header for unsafe methods
  const methodUpper = method.toUpperCase();
  if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(methodUpper)) {
    const xsrfToken = getCookie('XSRF-TOKEN') || localStorage.getItem('csrf_token');
    if (xsrfToken) {
      defaultHeaders['X-XSRF-TOKEN'] = xsrfToken;
    }
  }

  const mergedHeaders = { ...defaultHeaders, ...headers };

  try {
    const res = await fetch(url, {
      method,
      headers: mergedHeaders,
      body: body && !isFormData ? JSON.stringify(body) : body,
      credentials: 'include', // Ensure cookies are sent
      ...restOptions,
    });

    if (!res.ok) {
      const errorText = await res.text();
      const error = new Error(`HTTP ${res.status}: ${errorText}`);
      error.status = res.status;
      error.response = { status: res.status, data: errorText };
      throw error;
    }

    if (returnBlob) {
      return await res.blob();
    }


    // Attempt JSON parsing if response is not empty
    const text = await res.text();
    return text ? JSON.parse(text) : {};
  } catch (error) {
    if (error.response && error.response.status === 403 && !restOptions._retry) {
      try {
        const errorData = JSON.parse(error.response.data);
        const errDetail = errorData.error || {};

        // Check for specific CSRF errors
        if (errDetail.title === "CSRF Token Mismatch" || errDetail.title === "Missing CSRF Cookie") {
          console.warn("CSRF mismatch detected, attempting to refresh token...");

          // 1. Fetch fresh token from /auth/me
          const meRes = await fetch(`${API_BASE}/auth/me`, { credentials: 'include' });
          if (meRes.ok) {
            const meData = await meRes.json();
            if (meData.csrfToken) {
              console.log("CSRF token refreshed, retrying request...");
              // 2. Update Storage
              localStorage.setItem('csrf_token', meData.csrfToken);

              // 3. Retry original request with _retry flag
              return apiClient(route, {
                token,
                method,
                body,
                headers,
                returnBlob,
                ...restOptions,
                _retry: true
              });
            }
          }
        }
      } catch (retryError) {
        console.error("Failed to recover from CSRF error:", retryError);
      }
    }

    console.error("API Error:", error);
    throw error;
  }
}
